import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "@/views/LoginView.vue";
import PainelRootView from "@/views/PainelRootView.vue";
import EmpresaRootDetalheView from "@/views/EmpresaRootDetalheView.vue";
import { sso } from "roboflex-thalamus-sso-lib";
import { usuarioEhRoot } from "roboflex-thalamus-request-handler";
import EsqueceuSenhaView from "@/views/Senha/EsqueceuSenhaView.vue";
import GoogleLoginCallbackView from "@/views/GoogleLoginCallbackView.vue";
import ValidarTokenView from "@/views/Senha/ValidarTokenView.vue";
import { guardPermissaoRoute } from "@/services/funcionalidadeService";
import {
  enriquecerSessaoComMe,
  limparSessao,
  rotaInicialDoUsuario,
} from "@/services/sessionService";

async function guardMyroute(to, from, next) {
  if (!sso.validarSessao()) {
    next("/login");
    return;
  }

  try {
    const usuario = await enriquecerSessaoComMe();
    if (to.name === "home" && usuarioEhRoot(usuario)) {
      next({ name: "painelRoot" });
      return;
    }
    if (
      (to.name === "painelRoot" || to.name === "painelRootEmpresa") &&
      !usuarioEhRoot(usuario)
    ) {
      next({ name: "home" });
      return;
    }
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || !sso.validarSessao()) {
      limparSessao();
      next("/login");
      return;
    }
  }

  next();
}

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/painel-root",
    name: "painelRoot",
    component: PainelRootView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/painel-root/empresas/:id",
    name: "painelRootEmpresa",
    component: EmpresaRootDetalheView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/login/google-callback",
    name: "googleLoginCallback",
    component: GoogleLoginCallbackView,
  },
  {
    path: "/esqueci-minha-senha",
    name: "EsqueciMinhaSenha",
    component: EsqueceuSenhaView,
  },
  {
    path: "/validar-token",
    name: "ValidarToken",
    component: ValidarTokenView,
  },
  {
    path: "/pagina",
    name: "pagina",
    beforeEnter: guardPermissaoRoute,
    meta: { funcionalidadeId: 56 },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export { rotaInicialDoUsuario };
export default router;
